import { useState } from 'react';
import useListType from './useListType';

const useListFilters = Context => {
  const [type, setType] = useListType(Context);
  const [searchValue, setSearchValue] = useState('');

  return { type, setType, searchValue, setSearchValue };
};

export default useListFilters;
